export default "__VITE_ASSET__CFvl1g3t__"